export const moveScrollBySelector = (selector: string) => {
  setTimeout(() => {
    const targetElement = document.querySelector(selector);
    if (targetElement) {
      targetElement.scrollTop = targetElement.scrollHeight;
    }
  }, 500);
};
